export default __webpack_public_path__ + "static/titilliumweb-light-webfont-ef572cb3d398c389395e1ce14a1247a0.woff";